import { IInvoiceServiceCharge } from '../invoices.model';
import { InvoiceValidationError } from './types';
import { FileIcon, ReviewFileIcon, TimeIcon } from 'assets/icons';

export enum InvoiceTabEnum {
  BILL_TO = 'Bill to',
  INVOICE_OPTIONS = 'Invoice options',
  LINE_ITEMS = 'Line items',
  LINE_ITEMS_INPUT = 'LINE_ITEMS_INPUT',
  NOTES_ATTACHMENTS = 'Notes & Attachments',
  PAYMENT_OPTIONS = 'Payment options',
  PAYMENT_REMINDERS = 'Payment reminders',
  MORE_OPTIONS = 'More Options'
}

export const USPincodeRegex = new RegExp('^\\d{5}(?:[-\\s]\\d{4})?$');
export const emailRegex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[c\\w-]{2,4}$');

export enum InvoiceValidationErrorType {
  MIN_LINE_ITEM = 'minLineItem'
}

export const minimumLineItemsError: InvoiceValidationError = {
  type: InvoiceValidationErrorType.MIN_LINE_ITEM,
  errorMsg: 'Line Item is missing'
};

export const initServiceCharge: IInvoiceServiceCharge = {
  id: null,
  name: '',
  amount: '',
  percentage: '',
  taxes: [],
  totalAmount: ''
};

export enum InfoType {
  ERROR = 'ERROR',
  WARN = 'WARN'
}

// Firebase field name constants for auto-fill feature flags
export enum FIREBASE_FIELD {
  INVOICE_AUTOFILL_MODAL = 'hasSeenInvoiceAutoFillFeatureModal',
  INVOICE_AUTOFILL_BANNER = 'hasSeenInvoiceAutoFillFeatureBanner'
}

// Auto-fill feature list for invoices
export const INVOICE_AUTO_FILL_FEATURES = {
  title: 'Auto-fill your invoice',
  list: [
    {
      id: 'saves-time',
      title: 'Saves time',
      // eslint-disable-next-line quotes
      description: "We'll draft line items, totals, and customer info from what you upload or type.",
      Icon: TimeIcon
    },
    {
      id: 'works-with-files',
      title: 'Works with or without files',
      description: 'Upload a PDF/photo or just describe the job in a sentence.',
      Icon: FileIcon
    },
    {
      id: 'review-before-sending',
      title: 'Review before sending',
      description: 'You can edit anything before you create and share the invoice.',
      Icon: ReviewFileIcon
    }
  ]
};
